import { render } from "./ProposalsList.vue?vue&type=template&id=4311100e&scoped=true&ts=true"
import script from "./ProposalsList.vue?vue&type=script&lang=ts"
export * from "./ProposalsList.vue?vue&type=script&lang=ts"

import "./ProposalsList.vue?vue&type=style&index=0&id=4311100e&scoped=true&lang=scss"

import exportComponent from "/opt/apps/parcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4311100e"]])

export default __exports__